import { memo, useMemo } from 'react';
import { useSelector } from 'react-redux';

import { type FileExtensionName, fileExtensionStylingMap, genericFile } from '~/components/FileExtensionPreview/types';
import { CLIP_PREVIEW_IMAGE } from '~/constants/testIDs';
import {
  centralizedClipExtSelector,
  centralizedClipFormattedSizeSelector,
  centralizedDisplayTitleSelector,
} from '~/store/centralizedClip/selectors';

export const FileVisualizer = memo(() => {
  const ext = useSelector(centralizedClipExtSelector);
  const title = useSelector(centralizedDisplayTitleSelector);
  const formattedSize = useSelector(centralizedClipFormattedSizeSelector);

  const extStyles = useMemo(() => {
    const normalizedExt = ext?.toLowerCase() || ''; // to support e.g. JPG

    return normalizedExt in fileExtensionStylingMap
      ? // biome-ignore lint/plugin: Membership in fileExtensionStylingMap narrows the extension to a supported key.
        fileExtensionStylingMap[normalizedExt as FileExtensionName]
      : genericFile;
  }, [ext]);

  return (
    <div data-testid={CLIP_PREVIEW_IMAGE} className="flex min-h-[380px] flex-col items-center justify-center">
      <div
        className="flex size-[64px] items-center justify-center rounded-8"
        style={{
          backgroundColor: extStyles.bgColor,
          color: extStyles.iconColor,
        }}
      >
        <extStyles.iconComponent className="block" size={40} />
      </div>
      <div className="mt-4 font-medium ads:text-primary text-18 text-gray-12">{title}</div>
      <div className="mt-1 ads:text-metadata text-14 text-gray-10">{`${ext} ∙ ${formattedSize}`}</div>
    </div>
  );
});

FileVisualizer.displayName = 'FileVisualizer';
